<div class="modal-header bg-dark">
    <h4 class="modal-title">Marca da bollo pratica <strong>{{ request.IDRequest }}</strong></h4>
    <button type="button" class="close" aria-label="Chiudi" (click)="activeModal.dismiss()">
        <i class="icons-office-52"></i>
    </button>
</div>
<div class="modal-body revenue-stamp-body">
    <section class="revenue-stamp-preview" [class.revenue-stamp-preview-dark]="previewPane?.hasPdf">
        <div *ngIf="documentLoading" class="revenue-stamp-empty">Caricamento del documento…</div>
        <div *ngIf="!documentLoading && documentLoadFailed" class="revenue-stamp-empty">
            Impossibile caricare il documento della marca da bollo.
        </div>
        <div *ngIf="!documentLoading && !documentLoadFailed && !stampDocument" class="revenue-stamp-empty">
            Nessun documento di marca da bollo associato a questa pratica.
        </div>
        <app-document-preview-pane *ngIf="stampDocument"
                                   [fileName]="stampDocument.Path"
                                   [loadFile]="loadStampFile"
                                   [compact]="true"></app-document-preview-pane>
    </section>

    <div class="form-group revenue-stamp-field">
        <label class="control-label" for="revenue-stamp-value">Marca da Bollo</label>
        <input id="revenue-stamp-value"
               name="revenue-stamp-value"
               type="text"
               class="form-control form-white"
               maxlength="45"
               [(ngModel)]="revenueStamp"
               placeholder="Inserisci il numero della marca da bollo">
    </div>
    <p *ngIf="saveError" class="revenue-stamp-save-error">{{ saveError }}</p>
</div>
<div class="modal-footer">
    <button type="button"
            class="btn btn-default btn-blue btn-embossed"
            (click)="save()"
            [disabled]="saving">
        Salva
    </button>
    <button type="button" class="btn btn-default btn-embossed" (click)="activeModal.dismiss()">Chiudi</button>
</div>
